import React, { useState } from 'react';
import styled from 'styled-components';

const DEFAULT_STYLES = {
  SWITCH_WIDTH: 50,
  SWITCH_OFFSET: 4,
  KNOB_DIAMETER: 16,
};

interface ISwitcher {
  className?: string;
  isChecked: boolean;
  UncheckedIcon?: React.MemoExoticComponent<
    (props: React.SVGProps<SVGSVGElement>) => JSX.Element
  >;
  CheckedIcon?: React.MemoExoticComponent<
    (props: React.SVGProps<SVGSVGElement>) => JSX.Element
  >;
  onSwitch: (data?: any) => void;
}

export const Switcher = ({
  className,
  isChecked,
  CheckedIcon,
  UncheckedIcon,
  onSwitch,
}: ISwitcher): JSX.Element => {
  const [isCheckedState, setIsCheckedState] = useState(isChecked);

  const handleSwitch = () => {
    setIsCheckedState(prev => !prev);
    onSwitch();
  };

  return (
    <StyledWrapper
      className={className}
      onClick={handleSwitch}
      $isChecked={isCheckedState}
    >
      <StyledKnob $isChecked={isCheckedState}>
        {isCheckedState ? CheckedIcon : UncheckedIcon}
      </StyledKnob>
      <input
        type="checkbox"
        checked={isCheckedState}
        style={{ display: 'none' }}
      />
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div<{ $isChecked: boolean }>`
  width: ${DEFAULT_STYLES.SWITCH_WIDTH}px;
  height: ${DEFAULT_STYLES.KNOB_DIAMETER + 2 * DEFAULT_STYLES.SWITCH_OFFSET}px;
  border-radius: ${DEFAULT_STYLES.KNOB_DIAMETER}px;
  position: relative;
  transition: 0.3s;
  cursor: pointer;
  background: ${({ $isChecked }) => ($isChecked ? '#007aff' : '#c0c0c0')};
`;

const StyledKnob = styled.div<{ $isChecked: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;

  background: #fff;
  border-radius: 100%;
  height: ${DEFAULT_STYLES.KNOB_DIAMETER}px;
  width: ${DEFAULT_STYLES.KNOB_DIAMETER}px;
  position: absolute;
  top: ${DEFAULT_STYLES.SWITCH_OFFSET}px;
  left: ${({ $isChecked }) =>
    $isChecked
      ? DEFAULT_STYLES.SWITCH_WIDTH -
        DEFAULT_STYLES.KNOB_DIAMETER -
        DEFAULT_STYLES.SWITCH_OFFSET -
        1
      : DEFAULT_STYLES.SWITCH_OFFSET}px;
  transition: 0.3s;
`;
